import React from "react";
import { LegalPage } from "@/components/LegalPage";

export default function AiNotice() {
  return <LegalPage docKey="aiNotice" testId="legal-ai-notice-screen" />;
}
